import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Tooltip from '@/design_system/Tooltip';

export type RefashionStatus = 'applied' | 'not-applied-warranty' | 'not-applied-discount';

const RefashionLogo = ({
  size = 'medium',
  status = 'applied',
  tooltip,
}: {
  size?: 'small' | 'medium';
  status?: RefashionStatus;
  tooltip?: string;
}) => {
  const { t } = useLingui();

  const tooltipContent = {
    applied: t({ id: 'components.refashion', message: 'Repair bonus' }),
    'not-applied-warranty': t({
      id: 'components.refashion.not-applied-warranty',
      message: 'Bonus not applicable because the brand has been indicated as responsible',
    }),
    'not-applied-discount': t({
      id: 'components.refashion.not-applied-discount',
      message:
        'Bonus not applicable because, with the price reduction, the amount of the bonus would represent more than 60% of the price of the repair',
    }),
  } satisfies Record<RefashionStatus, string>;

  const label = tooltip ?? tooltipContent[status];

  return (
    <Tooltip content={label}>
      <Button variant="style-less" style={{ verticalAlign: 'middle' }}>
        <img
          src={status === 'applied' ? '/refashion.png' : '/refashion-not-applied.png'}
          style={
            size === 'medium'
              ? { width: '1.875rem', minWidth: '1.875rem' }
              : { width: '1.125rem', minWidth: '1.125rem' }
          }
          alt={label}
        />
      </Button>
    </Tooltip>
  );
};

export default RefashionLogo;
